import React from 'react'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from 'react-router-dom';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';

function MobileUnpaidInvoiceDetails() {
    const navigate = useNavigate();
  return (
        <div className='MainView'>
        <div className="drawerWithTop">
            {/* <MobileDrawer /> */}
            <ArrowBackIcon
            className="backArrowMobil"
            onClick={() => navigate("/Invoice")}
            />
            <h1>Unpaid Invoice</h1>
        </div>
        <div className='topSpace'></div>
        <div className='invoiceNameTile'>
            <div className='nameViewInvoice'>
                <p className='nameTxtInvoice'>Name :</p>
                <p className='userNameTxtInvoice'>Sagar Kasar</p>
            </div>
            <div className='nameViewInvoice'>
                <p className='nameTxtInvoice'>Wing/Flat No :</p>
                <p className='userNameTxtInvoice'>SaiSaya/Wing-A/F-102</p>
            </div>
            <div className='nameViewInvoice'>
                <p className='nameTxtInvoice'>Phone :</p>
                <p className='userNameTxtInvoice'>1234567890</p>
            </div>
            <div className='nameViewInvoice'>
                <p className='nameTxtInvoice'>Email :</p>
                <p className='userNameTxtInvoice'>testuser@gmail.com</p>
            </div>
            <div className='dividerCommon' />
            <div className='nameViewInvoice margineTopAdd'>
                <p className='nameTxtInvoice'>Invoice No :</p>
                <p className='userNameTxtInvoice'>10145</p>
            </div>
            <div className='nameViewInvoice'>
                <p className='nameTxtInvoice'>Invoice Date :</p>
                <p className='userNameTxtInvoice'>05/10/2023</p>
            </div>
            <div className='nameViewInvoice'>
                <p className='nameTxtInvoice'>Due Date :</p>
                <p className='userNameTxtInvoice'>31/12/2023</p>
            </div>
            <div className='nameViewInvoice'>
                <p className='nameTxtInvoice'>Period :</p>
                <p className='userNameTxtInvoice'>01/06/2023 to 31/09/2023</p>
            </div>
        </div>
      <div className='marginHorizontalCommon margineTopAdd'>
        <div className='famDetailsListInrMob'>
            <div className='famDetailsListTo'>
                <p className='userNameTxtInvoice'>Garden</p> 
                <p className='priceTxt'><CurrencyRupeeIcon sx={{fontSize:15}}/> 200</p>
            </div>
            <div className='dividerCommon' />
            <div className='famDetailsListTo'>
                <p className='userNameTxtInvoice'>Water Charges</p> 
                <p className='priceTxt'><CurrencyRupeeIcon sx={{fontSize:15}}/> 50</p>
            </div>
                  <div className='dividerCommon' />
                  <div className='famDetailsListTo'>
                <p className='userNameTxtInvoice'>Gym Charges</p> 
                <p className='priceTxt'><CurrencyRupeeIcon sx={{fontSize:15}}/> 250</p>
            </div>
            <div className='dividerCommon' />
            <div className='famDetailsListTo'>
                <p className='userNameTxtInvoice'>Garden Area</p> 
                <p className='priceTxt'><CurrencyRupeeIcon sx={{fontSize:15}}/> 10</p>
            </div>
                  <div className='dividerCommon' />
                  <div className='famDetailsListTo'>
                <p className='userNameTxtInvoice'>Sound System</p> 
                <p className='priceTxt'><CurrencyRupeeIcon sx={{fontSize:15}}/> 500</p>
            </div>
            <div className='dividerCommon' />
            <div className='famDetailsListTo'>
                <p className='userNameTxtInvoice'>CGST</p> 
                <p className='priceTxt'><CurrencyRupeeIcon sx={{fontSize:15}}/> 19.4</p>
            </div>
            <div className='dividerCommon' />
            <div className='famDetailsListTo'>
                <p className='userNameTxtInvoice'>SGST</p> 
                <p className='priceTxt'><CurrencyRupeeIcon sx={{fontSize:15}}/> 19.4</p>
            </div>
            <div className='dividerCommon' />
            <div className='famDetailsListTo'>
                <p className='userNameTxtInvoice'>Late Fees</p> 
                <p className='priceTxt'><CurrencyRupeeIcon sx={{fontSize:15}}/> 0</p>
            </div>
            <div className='dividerCommon' />
        </div>
        <div className='famDetailsListInrMob greenPanelInvoice'>
            <div className='famDetailsListTo'>
                <p className='userNameTxtInvoice txtColorWhite'>Advance Received</p> 
                <p className='priceTxt txtColorWhite'><CurrencyRupeeIcon sx={{fontSize:15}}/> 0</p>
            </div>
            <div className='dividerCommon dividerWhite' />
            <div className='famDetailsListTo'>
                <p className='userNameTxtInvoice txtColorWhite'>Total Payble</p> 
                <p className='priceTxt txtColorWhite'><CurrencyRupeeIcon sx={{fontSize:15}}/> 1049</p>
            </div>
        </div>
        <div>
            <p className='amountInWordTxt'>Amount in Words:</p>
            <p className='amountInWordTxt txtColorGreen'>One thousand, fourty nine Only</p>
        </div>
        <div className='famDetailsListInrMob margineTopAdd'>
            <p className='bankDetailsTxt'>Bank Details</p>
            <div className='bankDetailsView'>
                <p className='titleDesTxtInvoice'>Name of account</p>
                <p className='nameTxtInvoice'>Sagar S Kasar</p>
            </div>
            <div className='bankDetailsView'>
                <p className='titleDesTxtInvoice'>Account Number</p>
                <p className='nameTxtInvoice'>1574574879656</p>
            </div>
            <div className='famDetailsListTo'>
            <div className='bankDetailsView'>
                <p className='titleDesTxtInvoice'>Name of bank</p>
                <p className='nameTxtInvoice'>ICICI Bank</p>
            </div>
            <div className='bankDetailsView'>
                <p className='titleDesTxtInvoice'>Account Type</p>
                <p className='nameTxtInvoice'>Saving Account</p>
            </div>
            </div>
            <div className='famDetailsListTo'>
            <div className='bankDetailsView'>
                <p className='titleDesTxtInvoice'>IFSC Code</p>
                <p className='nameTxtInvoice'>ICICI000235</p>
            </div>
            <div className='bankDetailsView'>
                <p className='titleDesTxtInvoice'>MIRC Code</p>
                <p className='nameTxtInvoice'>ICICI000235</p>
            </div>
            </div>
            <div className='bankDetailsView'>
                <p className='titleDesTxtInvoice'>Bank Address</p>
                <p className='nameTxtInvoice'>Panchawati, near Nimani, Nashik </p>
            </div>
        </div>
        <div className='famDetailsListInrMob'>
            <p className='bankDetailsTxt'>Notes:</p>
            <p className='notePointsTxt'>1. Cheque should be drawn in favour of society only.</p>
            <p className='notePointsTxt'>2. Intrest @ 18% will be Charged for delayed payment.</p>
            <p className='notePointsTxt'>3. Plase mention Bill No. backside of cheque.</p>
            <div className='dividerCommon' />
            <div className='signTxtBox'>
                <p className='signTxtBottom'>Secretary / Chairman / Treasurer</p>
            </div>
        </div>
      </div>
      <div className='topSpace'></div>
      <div className='bottomBtnView'>
        <button className='submitButton' onClick={()=>navigate('/MobilePayNow')}>Proceed to Pay</button>
      </div>
    </div>
  )
}

export default MobileUnpaidInvoiceDetails